import { apiCreateBooking } from "../../api/createBooking";
import { BOOKING_CONFIRMATION_STEPS, BOOKING_STATUSES, isBookingStatusFatalError } from "../../constants";
import { apiUpdateCustomer } from "../../api/apiUpdateCustomer";
import { apiUpdateBooking } from "../../api/apiUpdateBooking";
import { apiUpdateBookingRestaurant } from "../../api/apiUpdateBookingRestaurant";
import { editBookingReset } from "./editBooking";

export const BOOKING_CONFIRMATION_RESET = 'BOOKING_CONFIRMATION_RESET';
export const bookingConfirmationReset = () => ({ type: BOOKING_CONFIRMATION_RESET });

export const BOOKING_CONFIRMATION_OPEN = 'BOOKING_CONFIRMATION_OPEN';
export const bookingConfirmationOpen = (isOpen = true) => ({ type: BOOKING_CONFIRMATION_OPEN, isOpen });

export const BOOKING_CONFIRMATION_SET_STEP = 'BOOKING_CONFIRMATION_SET_STEP';
const bookingConfirmationSetStep = step => ({ type: BOOKING_CONFIRMATION_SET_STEP, step });

export const BOOKING_CONFIRMATION_CREATE_STRIPE_INSTANCE = 'BOOKING_CONFIRMATION_CREATE_STRIPE_INSTANCE';
const bookingConfirmationCreateStripeInstance = instance => ({ type: BOOKING_CONFIRMATION_CREATE_STRIPE_INSTANCE, instance });

export const BOOKING_CONFIRMATION_SET_SETUP_INTENT_SECRET = 'BOOKING_CONFIRMATION_SET_SETUP_INTENT_SECRET';
const bookingConfirmationSetUpIntentSecret = secret => ({ type: BOOKING_CONFIRMATION_SET_SETUP_INTENT_SECRET, secret });

export const BOOKING_CONFIRMATION_SET_IS_SUBMITTING_CARD = 'BOOKING_CONFIRMATION_SET_IS_SUBMITTING_CARD';
const bookingConfirmationSetIsSubmittingCard = isSubmitting => ({ type: BOOKING_CONFIRMATION_SET_IS_SUBMITTING_CARD, isSubmitting });

export const BOOKING_CONFIRMATION_SET_ERROR_TEXT = 'BOOKING_CONFIRMATION_SET_ERROR_TEXT';
const bookingConfirmationSetErrorText = text => ({ type: BOOKING_CONFIRMATION_SET_ERROR_TEXT, text });

export const BOOKING_CONFIRMATION_SET_PAYMENT_REQUIRED_AMOUNT = 'BOOKING_CONFIRMATION_SET_PAYMENT_REQUIRED_AMOUNT';
const bookingConfirmationSetPaymentRequiredAmount = amount => ({ type: BOOKING_CONFIRMATION_SET_PAYMENT_REQUIRED_AMOUNT, amount });

export const BOOKING_CONFIRMATION_SET_REFERENCE_CODE = 'BOOKING_CONFIRMATION_SET_REFERENCE_CODE';
const bookingConfirmationSetReferenceCode = code => ({ type: BOOKING_CONFIRMATION_SET_REFERENCE_CODE, code });

export const BOOKING_CONFIRMATION_SET_FATAL_MESSAGE = 'BOOKING_CONFIRMATION_SET_FATAL_MESSAGE';
const bookingConfirmationSetFatalMessage = message => ({ type: BOOKING_CONFIRMATION_SET_FATAL_MESSAGE, message });

export const startBookingConfirmationProcess = () => async (dispatch, getState) => {
    dispatch(bookingConfirmationReset());
    dispatch(bookingConfirmationOpen(true));
    dispatch(bookingConfirmationSetErrorText(''));

    // First request to create booking
    const { storeReducer, bookingProcessReducer: booking, settingsReducer, editBookingState, storesReducer } = getState();

    try {
        localStorage.setItem('acceptedMarketing', booking.hasAcceptedEmailMarketing ? "true" : "false");
    } catch (error) {
        console.log(error);
    }

    const store = storeReducer.stores[storeReducer.storeIdSelected];
    let response = {};
    try {
        if (booking.isEditingBooking) {
            if (store.storeId === editBookingState.selectedStore.id) {
                console.log('Updating reservation');
                response = await apiUpdateBooking({
                    storeId: store.storeId,
                    bookingCode: editBookingState.bookingCode,
                    VisitDate: booking.dateSelected,
                    VisitTime: booking.timeSelected,
                    SpecialRequests: booking.specialRequests,
                    PartySize: booking.numberOfPeople,
                    name: booking.name,
                    surname: booking.surname,
                    mobilePhone: booking.mobilePhone,
                    mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
                    email: booking.email,
                    PromotionId: booking.promotionSelected,
                    receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
                    emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
                });
            } else {
                console.log('Updating reservation restaurant');
                const storeComplete = storesReducer.stores[storesReducer.selectedCountry.id]
                    .find(s => s.id === store.storeId);

                const resdiaryStoreName = storeComplete.plugins.resdiary.micrositeName;
                
                response = await apiUpdateBookingRestaurant({
                    storeId: editBookingState.selectedStore.id,
                    bookingCode: editBookingState.bookingCode,
                    newStoreName: resdiaryStoreName,
                    VisitDate: booking.dateSelected,
                    VisitTime: booking.timeSelected,
                    SpecialRequests: booking.specialRequests,
                    PartySize: booking.numberOfPeople,
                    name: booking.name,
                    surname: booking.surname,
                    mobilePhone: booking.mobilePhone,
                    mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
                    email: booking.email,
                    PromotionId: booking.promotionSelected,
                    receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
                    emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
                });
            }
        } else {
            response = await apiCreateBooking({
                storeId: store.storeId,
                VisitDate: booking.dateSelected,
                VisitTime: booking.timeSelected,
                SpecialRequests: booking.specialRequests,
                PartySize: booking.numberOfPeople,
                name: booking.name,
                surname: booking.surname,
                mobilePhone: booking.mobilePhone,
                mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
                email: booking.email,
                PromotionId: booking.promotionSelected,
                receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
                emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
            });
        }
    } catch (error) {
        console.log(error);
        dispatch(bookingConfirmationSetFatalMessage(settingsReducer.translations.label_error));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }

    const fatalErrorObject = isBookingStatusFatalError(response.Status, settingsReducer.translations);
    if (fatalErrorObject.error === true) {
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        dispatch(bookingConfirmationSetFatalMessage(fatalErrorObject.message));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }

    // If the status is successful no further action is required
    if (response.Status === BOOKING_STATUSES.SUCCESS) {
        dispatch(bookingConfirmationSetReferenceCode(response.Booking.Reference));
        if (booking.specialRequests) {
            console.log('Updating customer with comment');
            await apiUpdateCustomer({ 
                storeId: store.storeId, 
                customerId: response.Booking.Customer.Id, 
                specialRequests: booking.specialRequests,
                name: booking.name,
                surname: booking.surname,
                mobilePhone: booking.mobilePhone,
                mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
                email: booking.email,
                receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
                emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
            });
        }
        dispatch(editBookingReset());
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.SUCCESS));
    }

    // If we are editing a booking block the user here. (User should not be able to reach this point)
    if (booking.isEditingBooking) {
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        dispatch(bookingConfirmationSetFatalMessage(settingsReducer.translations.label_error_update_booking));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }

    let newStep = null;
    if (response.Status === BOOKING_STATUSES.PAYMENT_REQUIRED) {
        newStep = BOOKING_CONFIRMATION_STEPS.PAYMENT_REQUIRED;
        const stripeInstance = window.Stripe(
            response.StripePublishableKey,
            { stripeAccount: response.StripeAccountId }
        )
        dispatch(bookingConfirmationCreateStripeInstance(stripeInstance));
        dispatch(bookingConfirmationSetPaymentRequiredAmount(response.FormattedPaymentAmount));
        dispatch(bookingConfirmationSetStep(newStep));
        return;
    }

    if (response.Status === BOOKING_STATUSES.CREDIT_CARD_REQUIRED) {
        newStep = BOOKING_CONFIRMATION_STEPS.CREDIT_CARD_REQUIRED;
        const stripeInstance = window.Stripe(
            response.StripePublishableKey,
            { stripeAccount: response.StripeAccountId }
        )
        dispatch(bookingConfirmationCreateStripeInstance(stripeInstance));
        dispatch(bookingConfirmationSetUpIntentSecret(response.SetupIntentClientSecret));
        dispatch(bookingConfirmationSetStep(newStep));
        return;
    }

    return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
}

export const bookingConfirmationPayment = (stripe, card) => async (dispatch, getState) => {
    const { storeReducer, bookingProcessReducer: booking, bookingConfirmationReducer, settingsReducer } = getState();
    const store = storeReducer.stores[storeReducer.storeIdSelected];
    stripe = bookingConfirmationReducer.stripeInstance;
    let paymentMethod = null;
    dispatch(bookingConfirmationSetIsSubmittingCard(true));
    dispatch(bookingConfirmationSetErrorText(''));

    // Create the payment method
    try {
        const paymentMethodStripe = await stripe.createPaymentMethod({
            type: 'card',
            card
        });
        if (paymentMethodStripe.error) {
            throw paymentMethodStripe.error;
        }
        paymentMethod = paymentMethodStripe.paymentMethod;
    } catch (error) {
        dispatch(bookingConfirmationSetErrorText(error.message));
        return dispatch(bookingConfirmationSetIsSubmittingCard(false));
    }

    let response = {};
    try {
        response = await apiCreateBooking({
            storeId: store.storeId,
            VisitDate: booking.dateSelected,
            VisitTime: booking.timeSelected,
            SpecialRequests: booking.specialRequests,
            PartySize: booking.numberOfPeople,
            name: booking.name,
            surname: booking.surname,
            mobilePhone: booking.mobilePhone,
            mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
            email: booking.email,
            PromotionId: booking.promotionSelected,
            PaymentMethodId: paymentMethod.id,
            receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
            emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
        });
    } catch (error) {
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        dispatch(bookingConfirmationSetFatalMessage(settingsReducer.translations.label_error_server));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }

    let fatalErrorObject = isBookingStatusFatalError(response.Status, settingsReducer.translations);
    if (fatalErrorObject.error === true) {
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        dispatch(bookingConfirmationSetFatalMessage(fatalErrorObject.message));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }

    // If no authentication is required we exit
    if (response.Status === BOOKING_STATUSES.SUCCESS) {
        if (booking.specialRequests) {
            console.log('Updating customer with comment');
            await apiUpdateCustomer({ 
                storeId: store.storeId, 
                customerId: response.Booking.Customer.Id, 
                specialRequests: booking.specialRequests,
                name: booking.name,
                surname: booking.surname,
                mobilePhone: booking.mobilePhone,
                mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
                email: booking.email,
                receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
                emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
            });
        }
        dispatch(bookingConfirmationSetReferenceCode(response.Booking.Reference));
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.SUCCESS));
    }

    // If authentication is required we handle the action using stripe
    let paymentConfirmation = {};
    try {
        paymentConfirmation = await stripe.handleCardAction(
            response.PaymentIntentSecret,
        );
        if (paymentConfirmation.error) {
            throw paymentConfirmation.error;
        }
    } catch (error) {
        dispatch(bookingConfirmationSetErrorText(error.message));
        return dispatch(bookingConfirmationSetIsSubmittingCard(false));
    }

    // Submit to create booking again with the PaymentIntentSecret
    try {
        response = await apiCreateBooking({
            storeId: store.storeId,
            VisitDate: booking.dateSelected,
            VisitTime: booking.timeSelected,
            SpecialRequests: booking.specialRequests,
            PartySize: booking.numberOfPeople,
            name: booking.name,
            surname: booking.surname,
            mobilePhone: booking.mobilePhone,
            mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
            email: booking.email,
            PromotionId: booking.promotionSelected,
            PaymentMethodId: paymentMethod.id,
            PaymentIntentId: paymentConfirmation.paymentIntent.id,
            receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
            emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
        });
    } catch (error) {
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        dispatch(bookingConfirmationSetFatalMessage(settingsReducer.translations.label_error_server));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }

    fatalErrorObject = isBookingStatusFatalError(response.Status, settingsReducer.translations);
    if (fatalErrorObject.error === true) {
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        dispatch(bookingConfirmationSetFatalMessage(fatalErrorObject.message));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }

    if (response.Status === BOOKING_STATUSES.SUCCESS) {
        if (booking.specialRequests) {
            console.log('Updating customer with comment');
            await apiUpdateCustomer({ 
                storeId: store.storeId, 
                customerId: response.Booking.Customer.Id, 
                specialRequests: booking.specialRequests,
                name: booking.name,
                surname: booking.surname,
                mobilePhone: booking.mobilePhone,
                mobilePhoneCountryCode: booking.mobilePhoneCountryData.dialCode,
                email: booking.email,
                receiveEmailMarketing: booking.hasAcceptedEmailMarketing,
                emailMarketingOptInText: `${settingsReducer.translations.label_privacy_booking_first} Privacy Policy ${settingsReducer.translations.label_direct_marketing}`
            });
        }
        dispatch(bookingConfirmationSetReferenceCode(response.Booking.Reference));
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.SUCCESS));
    } else {
        dispatch(bookingConfirmationSetIsSubmittingCard(false));
        dispatch(bookingConfirmationSetFatalMessage(settingsReducer.translations.label_error_creation_booking));
        return dispatch(bookingConfirmationSetStep(BOOKING_CONFIRMATION_STEPS.ERROR));
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/bookingConfirmation.js